<template lang="pug">
  .component-tabbed-vehicle-reports
    .action-bar
      .title
        h2 Reports
      .action
        reporting-list-form(:type="'entity-filter'", @filterReportings="applyFilters")
        router-link(:to="{name:'create-reporting', params:{vehicleId:$route.params.id}}")
          i.fa.fa-plus-circle.fa-2x(data-toggle="create-card")
    .tabs-inner-content
      vehicle-damage-detail(ref="vehicleDamage" v-if="damagePositions", :items="damagePositions", :vehicle-damage-picture="item.category.damage_picture_external")
      base-list(:component="component", :dataLoader="dataLoader", :search="search")
</template>
<script type="text/babel">
import KeplerBackofficeSdk from "src/lib/kepler/backoffice";
import ReportingListForm from "../../structure/ui/filters/ReportingListForm";
import VehicleDamage from "../VehicleDamage.vue";
import BaseList from "../../../pages/backoffice/BaseList";
import VehicleDamageDetail from "../VehicleDamageDetail";

export default {
  name: "TabbedVehicleReports",
  components: {
    VehicleDamageDetail,
    BaseList,
    VehicleDamage,
    ReportingListForm
  },
  data() {
    return {
      damagePositions: [],
      component: require('src/components/backoffice/Reporting'),
      search: {
        vehicle_id: this.$route.params.id,
        status: null
      }
    }
  },
  created() {
    KeplerBackofficeSdk.reportings.list(1, -1, {vehicle_id: this.$route.params.id}).all((data) => {
      data.items.forEach((item) => {
        if (item.damage_position_raw && (item.status === 'PENDING_REVIEW' || item.status === 'CONFIRMED')) {
          item.damage_position_raw.forEach((damage) => {
            damage.id = item.id;
            damage.uid = item.uid;
            damage.description = item.description;
            damage.status = item.status;
            this.damagePositions.push(damage)
          })
        }
      });
      this.$refs.vehicleDamage.render()
    })
  },
  methods: {
    dataLoader(callback, page, resultsPerPage) {
      KeplerBackofficeSdk.reportings.list(page, resultsPerPage, this.search).all((data) => {
        callback(data)
      })
    },
    applyFilters(body) {
      this.$set(this.search, 'status', body.status)
      if (this.search.status === '') {
        delete this.search.status;
      }
    }
  },
  computed: {},
  props: {
    item: {
      default: null
    }
  }
}
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// VehicleReports.vue?7893f4f5